export const API_URL =
  process.env.REACT_APP_API_URL ||
  `${window.location.protocol}//${window.location.host}/graphql`;
